var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconAsk = function SvgIconAsk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3 3H43V43H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,41.1785033 L17.4929303,38.6409438 L18.0481004,38.7895658 C19.8011228,39.2588591 21.6317378,39.5 23.5,39.5 C34.0257939,39.5 42.5,31.8525457 42.5,22.5 C42.5,13.1474543 34.0257939,5.5 23.5,5.5 C12.9742061,5.5 4.5,13.1474543 4.5,22.5 C4.5,27.8076465 7.24011773,32.7231218 11.856257,35.9324597 L12.5,36.3800174 L12.5,41.1785033 Z",
    stroke: "#8D91A2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,22 C19.1192881,22 18,20.8807119 18,19.5 C18,18.1192881 19.1192881,17 20.5,17 C21.8807119,17 23,18.1192881 23,19.5 C23,20.8807119 21.8807119,22 20.5,22 Z M31.5,22 C30.1192881,22 29,20.8807119 29,19.5 C29,18.1192881 30.1192881,17 31.5,17 C32.8807119,17 34,18.1192881 34,19.5 C34,20.8807119 32.8807119,22 31.5,22 Z"
  }))));
};
export default SvgIconAsk;